import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  AbsenceService,
  AbsenceV2Service,
  ApplicationService,
  AttendantService,
  AuthenticationService,
  CallControlService,
  ConferenceService,
  Configuration,
  ConfigurationService,
  CustomerNotificationService,
  DirectoryService,
  DirectoryV2Service,
  LyncService,
  MediaAdministrationService,
  MessagingService,
  NameValueService,
  PushSubscriptionService,
  QueueControlService,
  ServiceAdministrationService,
  SettingsService,
  StatsticsService,
  SupportService,
  SynchronizationService,
  WhitepagesService
} from '@gt-api';
import {environment} from '@environment';
import {AbsenceServiceStub} from '@testhelper/swagger-service-stubs/absence.service.stub';
import {AbsenceV2ServiceStub} from '@testhelper/swagger-service-stubs/absenceV2.service.stub';
import {AttendantServiceStub} from '@testhelper/swagger-service-stubs/attendant.service.stub';
import {AuthenticationServiceStub} from '@testhelper/swagger-service-stubs/authentication.service.stub';
import {CallControlServiceStub} from '@testhelper/swagger-service-stubs/callControl.service.stub';
import {ConferenceServiceStub} from '@testhelper/swagger-service-stubs/conference.service.stub';
import {ConfigurationServiceStub} from '@testhelper/swagger-service-stubs/configuration.service.stub';
import {DirectoryServiceStub} from '@testhelper/swagger-service-stubs/directory.service.stub';
import {DirectoryV2ServiceStub} from '@testhelper/swagger-service-stubs/directoryV2.service.stub';
import {MessagingServiceStub} from '@testhelper/swagger-service-stubs/messaging.service.stub';
import {NameValueServiceStub} from '@testhelper/swagger-service-stubs/namevalue.service.stub';
import {PushSubscriptionServiceStub} from '@testhelper/swagger-service-stubs/push.subscription.service.stub';
import {QueueControlServiceStub} from '@testhelper/swagger-service-stubs/queue-control.service.stub';
import {ServiceAdministrationServiceStub} from '@testhelper/swagger-service-stubs/serviceAdministration.service.stub';
import {SettingsServiceStub} from '@testhelper/swagger-service-stubs/settings.service.stub';
import {StatsticsServiceStub} from '@testhelper/swagger-service-stubs/statstics-service.stub';
import {SynchronizationServiceStub} from '@testhelper/swagger-service-stubs/synchronization-service.stub';
import {WhitepagesServiceStub} from '@testhelper/swagger-service-stubs/whitepages.service.stub';
import {MediaAdministrationServiceStub} from '@testhelper/swagger-service-stubs/media-administration.service.stub';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    {
      provide: AbsenceService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new AbsenceService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new AbsenceServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: AbsenceV2Service,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new AbsenceV2Service(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new AbsenceV2ServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: ApplicationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new ApplicationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          // return new ApplicationServiceStub();
          console.error('ApplicationServiceStub not implemented');
          return {}; // TODO: create ApplicationServiceStub
        }
      },
      deps: [HttpClient]
    },
    {
      provide: AttendantService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new AttendantService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new AttendantServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: AuthenticationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new AuthenticationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new AuthenticationServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: CallControlService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new CallControlService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new CallControlServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: ConferenceService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new ConferenceService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new ConferenceServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: ConfigurationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new ConfigurationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new ConfigurationServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: CustomerNotificationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new CustomerNotificationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          // return new CustomerNotificationServiceStub();
          console.error('CustomerNotificationServiceStub not implemented');
          return {}; // TODO: create CustomerNotificationServiceStub
        }
      },
      deps: [HttpClient]
    },
    {
      provide: DirectoryService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new DirectoryService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new DirectoryServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: DirectoryV2Service,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new DirectoryV2Service(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new DirectoryV2ServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: LyncService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new LyncService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          // return new LyncServiceStub();
          console.error('LyncServiceStub not implemented');
          return {}; // TODO: create LyncServiceStub
        }
      },
      deps: [HttpClient]
    },
    {
      provide: MediaAdministrationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new MediaAdministrationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new MediaAdministrationServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: MessagingService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new MessagingService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new MessagingServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: NameValueService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new NameValueService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new NameValueServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: PushSubscriptionService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new PushSubscriptionService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new PushSubscriptionServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: QueueControlService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new QueueControlService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new QueueControlServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: ServiceAdministrationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new ServiceAdministrationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new ServiceAdministrationServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: SettingsService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new SettingsService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new SettingsServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: StatsticsService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new StatsticsService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new StatsticsServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: SupportService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new SupportService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          // return new SupportServiceStub();
          console.error('SupportServiceStub not implemented');
          return {}; // TODO: create SupportServiceStub
        }
      },
      deps: [HttpClient]
    },
    {
      provide: SynchronizationService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new SynchronizationService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new SynchronizationServiceStub();
        }
      },
      deps: [HttpClient]
    },
    {
      provide: WhitepagesService,
      useFactory: (httpClient: HttpClient) => {
        if (environment.apiUrl) {
          return new WhitepagesService(httpClient, environment.apiUrl, new Configuration({withCredentials: true}));
        } else {
          return new WhitepagesServiceStub();
        }
      },
      deps: [HttpClient]
    }
  ]
})
export class ApiMocksModule {
  public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiMocksModule> {
    return {
      ngModule: ApiMocksModule,
      providers: [{provide: Configuration, useFactory: configurationFactory}]
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiMocksModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiMocksModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule!\nSee also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
